<template lang="html">
  <section class="MarketPlace-AudioBook">
    <div class="container">
      <h1 class="mb-2 mt-4 ms-5">Here’s what’s new in audiobooks</h1>
      <div class="">
        <MarketPlaceCarouselListing />
      </div>
    </div>
  </section>
</template>

<script lang="js">

import { useStore } from 'vuex';
import { ref, computed } from 'vue';
import MarketPlaceCarouselListing from '@/components/partials/MarketPlaceCarouselListing.vue';

export default {
  name: 'MarketPlaceAudioBook',
  props: [],
  components: {
    MarketPlaceCarouselListing,
  },
  setup() {
    return {
    };
  },
  mounted() {

  },
  data() {
    return {

    };
  },
  methods: {

  },
  computed: {

  },
};
</script>

<style scoped lang="scss"></style>
